// extracted by mini-css-extract-plugin
export default {"root":"_12Crb","heading-and-subheading-block":"_23fpA","headingAndSubheadingBlock":"_23fpA","subheading":"_30CMR"};